!(function(root, factory) {
    "use strict";
    "function" == typeof define && define.amd
        ? define(["analyticstracker"], function(analyticstracker) {
              return (root.analyticsTransQA = factory(
                  analyticstracker,
                  window,
              ));
          })
        : "object" == typeof exports
        ? (module.exports = factory(require("analyticstracker"), window))
        : (root.analyticsTransQA = factory(root.analyticstracker, window));
})(this, function(analyticstracker, w) {
    "use strict";
    function analyticsTransQA() {
        if (!(this instanceof analyticsTransQA)) return new analyticsTransQA();
        (this.tracker = analyticstracker()),
            (this._version = "1.0.1"),
            this._subscribe();
    }
    var _instance;
    return (
        (analyticsTransQA.prototype.getInstance = function() {
            return (_instance = _instance || analyticsTransQA());
        }),
        (analyticsTransQA.prototype._subscribe = function() {
            try {
                this.tracker.trackingSubscribe("QA", function(event, data) {
                    try {
                        if (
                            void 0 !== w &&
                            null != w &&
                            void 0 !== w.sessionStorage
                        ) {
                            var eventLog = w.sessionStorage.getItem("eventLog");
                            (eventLog += "," + JSON.stringify(data)),
                                w.sessionStorage.setItem("eventLog", eventLog),
                                w.postMessage("analytics-track-change", "*");
                        }
                    } catch (err) {}
                });
            } catch (e) {}
        }),
        (analyticsTransQA.prototype.resetEventLog = function() {
            try {
                void 0 !== w &&
                    null != w &&
                    void 0 !== w.sessionStorage &&
                    w.sessionStorage.setItem("eventLog", "");
            } catch (e) {}
        }),
        (analyticsTransQA.prototype.setAvailableEvents = function(
            eventlist,
        ) {}),
        (_instance = analyticsTransQA()),
        analyticsTransQA.prototype.getInstance
    );
});
